/* Spell Forge — Main JS v8 */
(function(){
  'use strict';

  /* ---- Mobile nav ---- */
  var toggle   = document.getElementById('sf-menu-toggle');
  var nav      = document.getElementById('sf-mobile-nav');
  var overlay  = document.getElementById('sf-mobile-overlay');
  var closeBtn = document.getElementById('sf-nav-close');

  /* S'assurer que le menu est fermé au chargement */
  if(nav) {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
  }
  if(overlay) overlay.classList.remove('is-open');

  function openNav(){
    if(!nav) return;
    nav.classList.add('is-open');
    if(overlay) overlay.classList.add('is-open');
    nav.setAttribute('aria-hidden','false');
    if(toggle) toggle.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav(){
    if(!nav) return;
    nav.classList.remove('is-open');
    if(overlay) overlay.classList.remove('is-open');
    nav.setAttribute('aria-hidden','true');
    if(toggle) toggle.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }

  if(toggle) toggle.addEventListener('click', function(e){ e.stopPropagation(); openNav(); });
  if(closeBtn) closeBtn.addEventListener('click', closeNav);
  if(overlay) overlay.addEventListener('click', closeNav);

  /* Clic n'importe où sur la page ferme le menu */
  document.addEventListener('click', function(e){
    if(nav && nav.classList.contains('is-open') && !nav.contains(e.target) && e.target !== toggle){
      closeNav();
    }
  });

  /* Touche Escape */
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeNav(); });

  /* Clic sur un lien du menu ferme le menu */
  if(nav) nav.querySelectorAll('a').forEach(function(link){
    link.addEventListener('click', closeNav);
  });

  /* ---- Accordion Guides dans le menu mobile ---- */
  var accordion = document.querySelector('.sf-mobile-nav__accordion');
  if(accordion){
    accordion.addEventListener('click', function(e){
      e.stopPropagation();
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      var sub = this.nextElementSibling;
      if(sub) sub.classList.toggle('is-open', !expanded);
    });
  }

  /* ---- Dropdown desktop avec délai ---- */
  document.querySelectorAll('.sf-nav__dropdown').forEach(function(dropdown){
    var closeTimer = null;
    function openMenu(){ clearTimeout(closeTimer); dropdown.classList.add('is-open'); var t=dropdown.querySelector('.sf-nav__dropdown-trigger'); if(t)t.setAttribute('aria-expanded','true'); }
    function closeMenu(){ closeTimer=setTimeout(function(){ dropdown.classList.remove('is-open'); var t=dropdown.querySelector('.sf-nav__dropdown-trigger'); if(t)t.setAttribute('aria-expanded','false'); },120); }
    dropdown.addEventListener('mouseenter', openMenu);
    dropdown.addEventListener('mouseleave', closeMenu);
    var trigger=dropdown.querySelector('.sf-nav__dropdown-trigger');
    if(trigger) trigger.addEventListener('click',function(e){ e.preventDefault(); dropdown.classList.contains('is-open')?closeMenu():openMenu(); });
    document.addEventListener('click',function(e){ if(!dropdown.contains(e.target)){ dropdown.classList.remove('is-open'); if(trigger)trigger.setAttribute('aria-expanded','false'); } });
  });

  /* ---- Scroll reveal ---- */
  var revealEls=document.querySelectorAll('[data-reveal]');
  if(revealEls.length&&'IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.style.opacity='1'; e.target.style.transform='translateY(0)'; obs.unobserve(e.target); } });
    },{threshold:0.12});
    revealEls.forEach(function(el){ el.style.opacity='0'; el.style.transform='translateY(18px)'; el.style.transition='opacity 0.6s ease, transform 0.6s ease'; obs.observe(el); });
  }

  /* ---- Cart count ---- */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var badge=document.querySelector('.sf-cart-count');
    if(badge){ badge.textContent=cart.item_count; badge.style.display=cart.item_count>0?'flex':'none'; }
  }).catch(function(){});

  /* ---- Reviews carousel ---- */
  var track=document.getElementById('sf-reviews-track');
  var rdots=document.querySelectorAll('.sf-reviews-dot');
  var rprev=document.getElementById('sf-reviews-prev');
  var rnext=document.getElementById('sf-reviews-next');
  if(track){
    var count=track.children.length,idx=0;
    function go(n){ idx=(n+count)%count; track.style.transform='translateX(-'+(idx*100)+'%)'; rdots.forEach(function(d,i){d.classList.toggle('is-active',i===idx);}); }
    if(rprev)rprev.addEventListener('click',function(){go(idx-1);});
    if(rnext)rnext.addEventListener('click',function(){go(idx+1);});
    rdots.forEach(function(d){d.addEventListener('click',function(){go(+this.dataset.index);});});
    if(count>1) setInterval(function(){go(idx+1);},6000);
  }

  /* ---- Guide TOC active ---- */
  var tocLinks=document.querySelectorAll('.sg-toc__link');
  if(tocLinks.length&&'IntersectionObserver' in window){
    var sections=document.querySelectorAll('.sg-section[id]');
    var tocObs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ tocLinks.forEach(function(l){l.classList.remove('is-active');}); var a=document.querySelector('.sg-toc__link[href="#'+e.target.id+'"]'); if(a)a.classList.add('is-active'); }
      });
    },{rootMargin:'-20% 0px -70% 0px'});
    sections.forEach(function(s){tocObs.observe(s);});
  }

})();
